import { GcpFallback } from '@back-office/ui';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { InvitationStep } from '../../forms';
import Register from '../invitation/Register';
import useViewModel from './viewmodel';

export interface InvitationProps {
  isForgotPass: boolean;
}

const CreateNewPassword: FC<InvitationProps> = observer((props) => {
  const { isForgotPass } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const {
    control,
    step,
    errors,
    state,
    handleSubmit,
    watchPassword,
    watchConfirmPassword,
    handleOnSubmit,
    merchantName,
    goToLoginPage,
    goToEnterOtpPage,
    email,
  } = useViewModel({ isForgotPass });

  return (
    <>
      {step === InvitationStep.Register && (
        <Register
          control={control}
          email={email || ''}
          errors={errors}
          handleAtLeast={state.handleAtLeast}
          handleContainNumber={state.handleContainNumber}
          handleLowerCase={state.handleLowerCase}
          handleSpecialCharacter={state.handleSpecialCharacter}
          handleSubmit={handleSubmit}
          handleUpperCase={state.handleUpperCase}
          isValid={state.isValid}
          watchConfirmPassword={watchConfirmPassword}
          watchPassword={watchPassword}
          onSubmit={handleOnSubmit}
        />
      )}
      {step === InvitationStep.Success && isForgotPass && (
        <GcpFallback
          btn="login_form.sign_in"
          handleOnClick={goToLoginPage}
          title={t('invite_new_user.changed_password')}
        />
      )}
      {step === InvitationStep.Success && !isForgotPass && (
        <GcpFallback
          btn="invite_new_user.start"
          handleOnClick={goToEnterOtpPage}
          title={t('invite_new_user.accepted', { merchantName })}
        />
      )}
      {step === InvitationStep.Duplicate && (
        <GcpFallback
          btn="invite_new_user.start"
          handleOnClick={() => history.push('/login')}
          title={t('invite_new_user.invited', { merchantName })}
        />
      )}
    </>
  );
});

export default CreateNewPassword;
